import { render, staticRenderFns } from "./PatientHistoryTable.vue?vue&type=template&id=2b145205&"
import script from "./PatientHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports